import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import { CLOVER } from "@faire/retailer-visitor-shared/features/PointOfSale/consts";
import { usePOSSummary } from "@faire/retailer-visitor-shared/features/PointOfSale/hooks/usePOSSummary";
export var TooltipContent = function(param) {
    var ref = param.ref;
    var _usePOSSummary = usePOSSummary(), type = _usePOSSummary.type, posCompanyName = _usePOSSummary.name, locations = _usePOSSummary.locations;
    var multiLocationText = type === CLOVER ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
        id: "bDiiHS",
        defaultMessage: [
            {
                type: 0,
                value: "Stock count, synced from your connected "
            },
            {
                type: 1,
                value: "posCompanyName"
            },
            {
                type: 0,
                value: " account across all locations."
            }
        ],
        values: {
            posCompanyName: posCompanyName
        }
    }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
        id: "uorYMB",
        defaultMessage: [
            {
                type: 0,
                value: "Inventory in stock, synced from your connected "
            },
            {
                type: 1,
                value: "posCompanyName"
            },
            {
                type: 0,
                value: " account across all locations."
            }
        ],
        values: {
            posCompanyName: posCompanyName
        }
    });
    var singleLocationText = type === CLOVER ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
        id: "w9YYHi",
        defaultMessage: [
            {
                type: 0,
                value: "Stock count, synced from your connected "
            },
            {
                type: 1,
                value: "posCompanyName"
            },
            {
                type: 0,
                value: " account."
            }
        ],
        values: {
            posCompanyName: posCompanyName
        }
    }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
        id: "9KK5bg",
        defaultMessage: [
            {
                type: 0,
                value: "Inventory in stock, synced from your connected "
            },
            {
                type: 1,
                value: "posCompanyName"
            },
            {
                type: 0,
                value: " account."
            }
        ],
        values: {
            posCompanyName: posCompanyName
        }
    });
    return /*#__PURE__*/ _jsx(Typography, {
        color: "inherit",
        ref: ref,
        children: locations.length > 1 ? multiLocationText : singleLocationText
    });
};
